import { render, staticRenderFns } from "./NotificationTypeIconParts.vue?vue&type=template&id=84ac25a4&scoped=true"
import script from "./NotificationTypeIconParts.vue?vue&type=script&lang=ts"
export * from "./NotificationTypeIconParts.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTypeIconParts.vue?vue&type=style&index=0&id=84ac25a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ac25a4",
  null
  
)

export default component.exports